import script from "./Alarms.vue?vue&type=script&setup=true&lang=js"
export * from "./Alarms.vue?vue&type=script&setup=true&lang=js"

import "./Alarms.vue?vue&type=style&index=0&id=6bc5394d&lang=scss&scoped=true"

import exportComponent from "/root/buildarea/boeingdl-dev-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6bc5394d"]])

export default __exports__